angular.module('picmonic-common').directive('cookieBanner', function () {
  return {
    restrict: 'E',
    replace: true,
    template:
      '<div class="cookie-banner" ng-show="visible" style="position: fixed; width: 100%; bottom: 0; display: flex; color: #FFFFFF; font-size: 12px; background-color: #323A4D; padding: 8px 16px; align-items: center;justify-content: space-between; z-index:99">\n' +
      '        <div class="text-container">' +
      '            We use cookies to offer you a better experience and to analyze site traffic. By continuing to use this website you consent to the use of cookies in accordance with our <a class="pls-blue underline" href="https://www.picmonic.com/pages/cookie-policy" target="_blank">Cookie Policy</a>.' +
      '        </div>' +
      '        <div>' +
      '            <a class="pls-btn pls-btn--lighten-blue m-r-10" ng-click="accept()">ACCEPT</a>' +
      '        </div>' +
      '    </div>',
    scope: {},
    controller: [
      '$scope',
      '$cookies',
      function ($scope, $cookies) {
        $scope.visible = !$cookies.get('cookie_consent');

        $scope.accept = function () {
          if (typeof atlasEvent !== 'undefined') {
            atlasEvent('click', 'cookie_consent');
            var expires = new Date();
            expires.setTime(expires.getTime() + 10 * 365 * 24 * 60 * 60 * 1000);
            $cookies.put('cookie_consent', 1, { expires: expires });
            $scope.visible = false;
          }
        };
      },
    ],
  };
});
